module.exports = __webpack_public_path__ + "img/051-cleaning.3c839c6c.svg";